import React from 'react';

interface ScannerManualInputProps {
  manualCode: string;
  isScanning: boolean;
  onManualCodeChange: (code: string) => void;
  onSubmitManual: () => void;
}

export const ScannerManualInput: React.FC<ScannerManualInputProps> = ({
  manualCode,
  isScanning,
  onManualCodeChange,
  onSubmitManual,
}) => {
  return (
    <div className="mt-5 pt-4 border-t border-slate-100">
      <label className="block text-xs font-semibold text-slate-600 mb-1.5">
        Atau Masukkan Kode UIBN Manual
      </label>
      <div className="flex gap-2">
        <input
          id="input-manual-uibn"
          type="text"
          placeholder="Contoh: UIBN-979-8042-1001-9"
          value={manualCode}
          onChange={(e) => onManualCodeChange(e.target.value)}
          className="flex-1 px-3.5 py-2.5 min-h-[44px] text-xs font-mono border border-slate-300 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-600 uppercase"
        />
        <button
          type="button"
          disabled={!manualCode.trim() || isScanning}
          onClick={onSubmitManual}
          className="px-4 py-2.5 min-h-[44px] bg-slate-900 hover:bg-slate-800 text-white rounded-xl text-xs font-medium transition disabled:opacity-40 cursor-pointer flex items-center justify-center"
        >
          Cari
        </button>
      </div>
    </div>
  );
};
